import { MakeCall } from './createMakeCall';
import { Conversation } from './types/Conversation';

const finalizeBooking = (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Conversation>(
    'PUT',
    `/api/v2/conversation/${conversationId}/finalize`,
  );
export { finalizeBooking };
